import { useMutation } from 'react-query';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { SessionInspectorDetail } from '@utils/types/back-office/session-inspector';

export const SESSION_INSPECTOR_DETAIL_KEY = 'session-inspector-detail';

export const useGetSessionDetail = (sessionId: string | null) => {
  const fetchDetail = async (): Promise<SessionInspectorDetail> => {
    const { data } = await Axios.get<SessionInspectorDetail>(
      `/api/admin/session-inspector/${sessionId}`
    );
    return data;
  };

  return useQuery<SessionInspectorDetail>(
    [SESSION_INSPECTOR_DETAIL_KEY, sessionId],
    fetchDetail,
    {
      enabled: Boolean(sessionId),
      staleTime: 15_000,
      refetchOnWindowFocus: false
    }
  );
};

export const useRehydrateSession = () => {
  return useMutation(async (zoomId: string) => {
    const { data } = await Axios.post(
      `/api/v3/speech-to-text/session/${zoomId}/rehydrate`
    );
    return data;
  });
};
